import Action from "./action";

/**
 * Action to add an item to the cart.
 * 
 * For an example config object, see TODO!
 */
class CartAttributesAction extends Action {
  type = "cart.attributes";

  attributes = {};
  clearedAttributes = {};

  /**
   * Constructor
   * @param {Object} config 
   */
  constructor(config = {}) {
    super(config);

    // Convert array of key value pairs to object with keys and values
    this.attributes = Object.fromEntries(
      this.config.attributes.map(item => [item.key, item.value])
    );

    // To remove cart attributes we need to set them all to an empty string.
    this.clearedAttributes = Object.fromEntries(
      this.config.attributes.map(item => [item.key, ""])
    );
  }

  /**
   * Execute the action
   * @param {Object} data 
   */
  async execute(data) {
    this.log = [];
    console.groupCollapsed(this.logPrefix);
    console.log('Config', this.config);
    console.log('Data', data);

    const result = await this.applyAttributes(this.attributes);

    console.log('Added!', result);
    console.groupEnd();
    this.addLog(result, "Applied attributes");
  }

  /**
   * Undo the action
   * @param {Object} data 
   */
  async undo(data) {
    this.log = [];
    console.groupCollapsed(this.logPrefix);
    console.log('Undoing', this.config);

    const result = await this.applyAttributes(this.clearedAttributes);

    console.log("Cleared attributes");
    console.groupEnd();
    this.addLog(result, "Cleared attributes", "", "undo");
  }

  // TODO: Probably want to move this to cart.js...
  async applyAttributes(attributes) {
    let body = JSON.stringify({ attributes: attributes });
    // @ts-ignore
    let response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: "POST",
      headers: { 'Content-Type': 'application/json' },
      body
    });
    return await response.json();
  }


  explainAction() {
    return `${Object.entries(this.attributes).map(([k, v]) => `Set cart ${Object.keys(this.attributes).length > 1 ? 'attributes' : 'attribute'} '${k}' = '${v}'`).join(' and ')}`;
  }

  explainUndo() {
    if(this.config.bidirectional){
      return `Unset cart ${Object.keys(this.attributes).length > 1 ? 'attributes' : 'attribute'} ${Object.keys(this.attributes).map(k => `'${k}'`).join(' and ')}`;
    }
  }
}

export default CartAttributesAction;